export default __webpack_public_path__ + "static/2-cb2ae851f5a9ae6d04b6adf07d129cb8.png";